<template>
  <div>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="4" v-if="likeComponent">
            <template>
              <v-text-field
                v-model="organisation.inn"
                label="ИНН"
                key="2"
                append-outer-icon="mdi-magnify"
                readonly
                class="innEditOff noHover"
                @click:append-outer="OnChangeINNLupa()"
              ></v-text-field>
            </template>
          </v-col>
          <v-col cols="4" v-else>
            <template v-if="organisation.JurIPSam == 'Jur'">
              <v-text-field
                v-model="organisation.inn"
                counter="10"
                v-mask="'##########'"
                label="ИНН"
                key="2"
                append-outer-icon="mdi-magnify"
                @click:append-outer="OnChangeINNLupa()"
                :disabled="!checkRole(roleObj.adminService) | loading"
              ></v-text-field>
            </template>
            <template v-else-if="organisation.JurIPSam == 'IP'">
              <v-text-field
                v-model="organisation.inn"
                counter="12"
                v-mask="'############'"
                :disabled="!checkRole(roleObj.adminService) | loading"
                label="ИНН"
                key="3"
                append-outer-icon="mdi-magnify"
                @click:append-outer="OnChangeINNLupa('ИП')"
              ></v-text-field>
            </template>
            <template v-else-if="organisation.JurIPSam == 'SZ'">
              <v-text-field
                v-model="organisation.inn"
                counter="12"
                v-mask="'############'"
                :disabled="!checkRole(roleObj.adminService) | loading"
                label="ИНН"
                key="3"
              ></v-text-field>
            </template>
          </v-col>
          <v-col cols="4">
            <template v-if="organisation.JurIPSam == 'Jur'">
              <v-text-field
                counter="13"
                v-mask="'#############'"
                v-model="organisation.ogrn"
                label="ОГРН"
                key="3"
                :disabled="!checkRole(roleObj.admin)"
              ></v-text-field>
            </template>
            <template v-else-if="organisation.JurIPSam == 'IP'">
              <v-text-field
                counter="15"
                v-mask="'###############'"
                v-model="organisation.ogrn"
                label="ОГРНИП"
                key="4"
                :disabled="!checkRole(roleObj.admin)"
              ></v-text-field>
            </template>
          </v-col>
          <v-col cols="4">
            <template v-if="organisation.JurIPSam == 'Jur'">
              <v-text-field
                counter="9"
                v-mask="'#########'"
                v-model="organisation.kpp"
                label="КПП"
                :disabled="!checkRole(roleObj.admin)"
              ></v-text-field>
            </template>
          </v-col>
        </v-row>
        <template v-if="organisation.JurIPSam == 'Jur'">
          <v-text-field
            v-model="organisation.orgName"
            label="Полное наименование организации"
            :rules="rules.orgRuleRequired"
            :disabled="!checkRole(roleObj.admin)"
            auto-grow
          ></v-text-field>
        </template>
        <template v-if="organisation.JurIPSam == 'Jur'">
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="organisation.orgShortName"
                dense
                label="Сокращенное наименование организации"
                :disabled="!checkRole(roleObj.admin)"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="organisation.pravForm"
                :items="orgPravForm"
                dense
                label="Правовая форма"
                item-text="name"
                item-value="id"
                clearable
                :disabled="!checkRole(roleObj.admin)"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                v-model="organisation.nologObl"
                :items="vidnologObl"
                dense
                label="Система налогообложения"
                item-text="name"
                item-value="name"
                clearable
                :disabled="!checkRole(roleObj.admin)"
              ></v-select>
            </v-col>
          </v-row>
        </template>
        <template v-else-if="organisation.JurIPSam == 'IP'">
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="organisation.pravForm"
                :items="orgPravFormIP"
                dense
                label="Правовая форма"
                item-text="name"
                item-value="id"
                key="5"
                clearable
                :disabled="!checkRole(roleObj.admin)"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="organisation.nologObl"
                :items="vidnologObl"
                dense
                label="Система налогообложения"
                item-text="name"
                item-value="name"
                key="6"
                clearable
                :disabled="!checkRole(roleObj.admin)"
              ></v-select>
            </v-col>
          </v-row>
        </template>

        <v-row>
          <v-col cols="3">
            <v-text-field
              v-model="organisation.directorDolgn"
              label="Должность руководителя"
              :disabled="!checkRole(roleObj.admin)"
            ></v-text-field>
          </v-col>

          <v-col cols="3">
            <v-text-field
              v-model="organisation.directorFamil"
              label="Фамилия"
              :disabled="!checkRole(roleObj.admin)"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="organisation.directorName"
              label="Имя"
              :disabled="!checkRole(roleObj.admin)"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="organisation.directorOtch"
              label="Отчество"
              :disabled="!checkRole(roleObj.admin)"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-textarea
          rows="1"
          auto-grow
          v-model="organisation.jurrAddr"
          label="Юридический адрес"
          :disabled="!checkRole(roleObj.admin)"
        ></v-textarea>
        <v-checkbox
          @change="CopyJurToFact($event)"
          v-model="organisation.jurAddrSovpSFactich"
          dense
          label="Фактический адрес совпадает с юридическим"
          :disabled="!checkRole(roleObj.admin)"
        ></v-checkbox>
        <template v-if="!organisation.jurAddrSovpSFactich">
          <v-textarea
            rows="1"
            auto-grow
            v-model="organisation.factAddr"
            label="Фактический адрес"
            :disabled="!checkRole(roleObj.admin)"
          ></v-textarea>
        </template>

        <!-- <v-textarea
            rows="1"
            auto-grow
            v-model="organisation.addrPoluchKorresp"
            label="Адрес для получения корреспонденции"
                  ></v-textarea>-->

        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="organisation.directorPhone"
              label="Телефон"
              placeholder="(xxx)xxx xx xx"
              prepend-icon="phone"
              v-mask="rules.phonemask"
              prefix="+7"
              :disabled="!checkRole(roleObj.admin)"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="organisation.directorEmail"
              label="Email адрес"
              prepend-icon="email"
              placeholder="Email адрес"
              :disabled="!checkRole(roleObj.admin)"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions
      class="flex-center"
      style="height: 80px"
      v-if="!likeComponent"
    >
      <v-btn class="accent" @click.prevent="UpdateAgentOrgInfo()"
        >Сохранить
      </v-btn>
    </v-card-actions>
    <v-card-actions class="flex-center" style="height: 80px" v-else>
      <span v-if="autosave">Обновленная информация сохранена</span>
    </v-card-actions>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Globalrules from "@/components/api/rules.js";
import {roleObj} from '@/plugins/roles'
export default {
  components: {},
  data() {
    return {
      roleObj,
      dubl: null,
      loading: false,
      rules: Globalrules,
      activeBtn: 0,
      showNav: true,
      valid: true,
      autosave: false,
      organisation: {
        JurIPSam: "",
        orgName: "",
        orgShortName: "",
        pravForm: 1,
        nologObl: 0,
        inn: "",
        ogrn: "",
        kpp: "",
        okato: "",
        oktmo: "",
        directorDolgn: "",
        directorFamil: "",
        directorName: "",
        directorOtch: "",
        directorPhone: "",
        directorEmail: "",
        directorPassportSer: "",
        directorPassportNumber: "",
        directorPassportVidan: "",
        directorPassportDataVidachi: "",
        directorPassportKodPord: "",
        jurrAddr: "",
        factAddr: "",
        jurAddrSovpSFactich: true,
        addrForCorrespondence: "3",
        address: "",
      },
      orgPravForm: [
        { name: "ООО", id: "1" },
        { name: "АО (ПАО, ЗАО) ", id: "2" },
        { name: "Иная ", id: "3" },
        // { name: "Индивидуальный предриниматель ", id: "4" }
      ],
      orgPravFormIP: [
        { name: "ИП", id: "3" },
        // { name: "Индивидуальный предриниматель ", id: "4" }
      ],
      vidnologObl: [
        { name: "ОСН", id: 1 },
        { name: "УСН", id: 2 },
        { name: "Другая", id: 3 },
      ],
    };
  },
  props: {
    likeComponent: { type: Boolean, default: false },
  },
  methods: {
    CopyJurToFact(val) {
      if (val === true) {
        this.organisation.factAddrIndex = this.organisation.jurAddrIndex;
        this.organisation.factAddrCountry = this.organisation.jurAddrCountry;
        this.organisation.factAddrRegion = this.organisation.jurAddrRegion;
        this.organisation.factAddrRaion = this.organisation.jurAddrRaion;
        this.organisation.factAddrGorIliNasPunkc = this.organisation.jurAddrGorIliNasPunkc;
        this.organisation.factAddrStreet = this.organisation.jurAddrStreet;
        this.organisation.factAddrDomOficeKvartira = this.organisation.jurAddrDomOficeKvartira;
        this.organisation.factAddrOfice = this.organisation.jurAddrOfice;
        this.organisation.factAddrKvartira = this.organisation.jurAddrKvartira;
      }
    },
    OnChangeJurAddr(val, rekv) {
      if (this.organisation.jurAddrSovpSFactich) {
        this.organisation[rekv] = val;
      }
    },
    OnChangeINNLupa(ip) {
      this.loading = true;

      this.$store
        .dispatch("FillByINN", this.organisation)
        .then((res) => {
          if (res.status_api === "gosebase") {
            const data = res.data.main.data;
            this.organisation.inn = data.inn;
            this.organisation.orgName =
              data.name && data.name.full_with_opf
                ? data.name.full_with_opf
                : "";
            this.organisation.orgShortName =
              data.name && data.name.short_with_opf
                ? data.name.short_with_opf
                : "";
            this.organisation.kpp = data.kpp;
            this.organisation.ogrn = data.ogrn;
            this.organisation.jurrAddr =
              data.address && data.address.unrestricted_value
                ? data.address.unrestricted_value
                : "";
            this.organisation.okato = data.okato;
            this.organisation.oktmo = data.oktmo;
            this.organisation.address =
              data.address && data.address.unrestricted_value
                ? data.address.unrestricted_value
                : "";
            if (data.management && data.management.name) {
              let FIO = data.management.name.split(" ");
              this.organisation.directorFamil = FIO[0];
              this.organisation.directorName = FIO[1];
              this.organisation.directorOtch = FIO[2];
              if (ip === undefined) {
                this.organisation.directorDolgn =
                  data.management && data.management.post
                    ? data.management.post
                    : "";
              } else {
                this.organisation.directorDolgn = ip;
              }
            }
          } else if (res.status_api === "dadata") {
            const data = res.data[0];
            this.organisation.inn = data.inn;
            this.organisation.orgName = data.longName;
            this.organisation.orgShortName = data.name;
            this.organisation.kpp = data.kpp;
            this.organisation.ogrn = data.ogrn;
            this.organisation.jurrAddr = data.address;
            this.organisation.okato = data.okato;
            this.organisation.oktmo = data.oktmo;
            this.organisation.address = data.address;
            if (data.directorName) {
              let FIO = data.directorName.split(" ");
              this.organisation.directorFamil = FIO[0];
              this.organisation.directorName = FIO[1];
              this.organisation.directorOtch = FIO[2];
              if (ip === undefined) {
                this.organisation.directorDolgn = data.directorDolgn;
              } else {
                this.organisation.directorDolgn = ip;
              }
            }
          } else {
            Swal.fire({
              icon: "warning",
              title: "ИНН в базе данных отсутствует.",
              text: "Проверьте, правильно ли вы его указали",
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          Swal.fire({
            icon: "error",
            title: "Что то пошло не так!",
            text: "Мы не нашли такой ИНН",
          });
        });
    },
    comeTo(name) {
      this.$router.push("/" + name);
    },
    UpdateAgentOrgInfo() {
      this.$store.dispatch("updateAgentFirm", this.organisation).then(() => {
        this.organisation = this.$store.getters.getOrganisationAgent;
        if (!this.likeComponent) {
          Swal.fire({
            icon: "success",
            title: "Информация обновена",
            text: "Вся информация по компании обновлена",
          });
        }else{
          this.$emit('valid', this.valid)
          this.$emit('organization', this.organisation)
        }
      });
    },
    autosaveInterval() {
      const int = setInterval(() => {
        if (this.likeComponent){
          if(JSON.stringify(this.organisation) !== JSON.stringify(this.dubl)) {
            this.autosave = true
            this.UpdateAgentOrgInfo();
            this.dubl = Object.assign({},this.organisation)
            setTimeout(()=>{this.autosave = false},3000)
          }
          this.$emit('valid', this.valid)
        }
      }, 1000);
      window.interval = int;
    },
  },
  // проверим не изменилась ли инфа по сравнению с тем, которая загрузилась.
  beforeRouteLeave: function (to, from, next) {
    if (!this.$store.getters.isAuthenticated) {
      next();
      return;
    }
    if (!(JSON.stringify(this.organisation) == JSON.stringify(this.dubl))) {
      Swal.fire({
        title: "Данные были изменены",
        text: "Сохранить данные?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Да!",
        cancelButtonText: "Нет.",
      }).then((result) => {
        if (result.value) {
          this.UpdateAgentOrgInfo();
          next();
        } else {
          next();
        }
      });
    } else {
      next();
    }
  },
  mounted() {
    this.$store.dispatch("getOrgSettings").then(() => {
      this.items = this.$store.getters.getOrgTabs;
    });

    this.$store.dispatch("getAgentFirm").then(() => {
      this.organisation = this.$store.getters.getOrganisationAgent;
      this.dubl = Object.assign({}, this.organisation);
    });
    this.autosaveInterval();
  },
};
</script>

<style lang="scss" scoped>
.subheader1 {
  font-size: 24px !important;
  color: #217899 !important;
}
.subheader2 {
  font-size: 24px !important;
  font-weight: 700 !important;
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

